//
// BEDC / ROME Environments
//

// for local development
const localBedcEnvironments = ['local', 'local-staging'] as const;

const awsBedcEnvironments = [
	'dev',
	'test',
	'prod',
	// this is a stub type
	// to support a feature branch environments
	'rome1234',
] as const;

export const bedcEnvironments = [...localBedcEnvironments, ...awsBedcEnvironments] as const;

//
// CARTERS Environments
//

const localCartersEnvironments = [
	// for local development
	'carters-local-dev',
	'carters-local-test',
] as const;

const awsCartersEnvironments = [
	// for AWS envs
	'carters-dev',
	'carters-test',
	'carters-prod',
] as const;

export const cartersEnvironments = [
	...localCartersEnvironments,
	...awsCartersEnvironments,
] as const;

//
// Legacy Environments
// related to the old web-portal project
// Kept because cdk/deep-archive manifests still refers to them
// @see https://github.com/building-estimates/web-portal
//

const legacyEnvironments = ['legacy-dev', 'legacy-test', 'legacy-prod'] as const;

//
// All Environments
//

export const localEnvironments = [...localBedcEnvironments, ...localCartersEnvironments] as const;

export const awsEnvironments = [...awsBedcEnvironments, ...awsCartersEnvironments] as const;

export const devEnvironments = ['dev', 'carters-dev'] as const;
export const testEnvironments = ['test', 'carters-test'] as const;
export const prodEnvironments = ['prod', 'carters-prod'] as const;

export const environments = [
	...localEnvironments,
	...awsEnvironments,
	...legacyEnvironments,
] as const;

//
// The client-facing name.
//
// **Deliberately still written out, and deliberately narrower than `environments`.** It omits
// `rome1234` and the three legacy names, because the client has no configuration for them and
// widening it would make every exhaustive switch on a `Name` incomplete. Deriving it from the array
// above would be tidier and would change behaviour, so the duplication stays and the constant list
// — the half that was actually drifting — does not.
//
export type Name = Exclude<
	(typeof environments)[number],
	'rome1234' | 'legacy-dev' | 'legacy-test' | 'legacy-prod'
>;
